import { render, staticRenderFns } from "./syncDevice.vue?vue&type=template&id=27dc4fe4&scoped=true"
import script from "./syncDevice.vue?vue&type=script&lang=js"
export * from "./syncDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc4fe4",
  null
  
)

export default component.exports